import { render, staticRenderFns } from "./UberMenus.vue?vue&type=template&id=2d152b01&scoped=true"
import script from "./UberMenus.vue?vue&type=script&lang=js"
export * from "./UberMenus.vue?vue&type=script&lang=js"
import style0 from "./UberMenus.vue?vue&type=style&index=0&id=2d152b01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d152b01",
  null
  
)

export default component.exports